// @flow
import camelCase from 'lodash/camelCase';
import isFunction from 'lodash/isFunction';
import isObject from 'lodash/isObject';

export default class ObjectUtils {
  static camelCaseKeys(obj: any): any {
    if (!isObject(obj)) return obj;

    // the major use for this method is transforming before sending requests
    // so mimic JSON.stringify, replacing functions will nulls
    if (isFunction(obj)) return null;

    // if any of these array items are objects,
    // they will also get camel-cased
    if (Array.isArray(obj)) return obj.map(ObjectUtils.camelCaseKeys);

    return Object.keys(obj).reduce((memo: Object, key: string) => {
      let value = obj[key];

      // don't copy functions over, since the contexts of the functions would be changing
      if (isFunction(value)) return memo;

      // recursively camelCase keys of nested objects and arrays
      if (isObject(value)) {
        value = ObjectUtils.camelCaseKeys(value);
      }

      return { ...memo, [camelCase(key)]: value };
    }, {});
  }
}
